// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2QGBs","open":"open___2pP2I","cell":"cell___2cdJ7","logo":"logo___2yCij","name":"name___3CX5R"};